<app-content-viewer [content]="content" ></app-content-viewer>
